<template>
  <q-card>
    <q-toolbar>
      <q-toolbar-title class="text-center">
        Data Deletion Request
      </q-toolbar-title>
    </q-toolbar>
    <q-separator />
    <q-card-section>
      <message
        type="positive"
        class="animated fadeIn"
      >
        Your data has been successfully deleted from Private Footprint.
      </message>
    </q-card-section>
  </q-card>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Message from '@/components/message/Message.vue';

export default defineComponent({
  meta: {
    title: 'Data Deletion Request',
  },
  components: { Message },
});
</script>
